import { Swal } from "@js/index";

document.addEventListener("DOMContentLoaded", () => {
  const toggles = document.querySelectorAll(".notification-toggle");

  toggles.forEach((toggle) => {
    toggle.addEventListener("change", async (event) => {
      const setting = event.target.getAttribute("data-setting");
      const value = event.target.checked;
      const csrfToken = document.querySelector('meta[name="_csrf"]')?.getAttribute("content");
      const csrfHeader = document
        .querySelector('meta[name="_csrf_header"]')
        ?.getAttribute("content");

      try {
        // Handle Push Notification Permission separately before saving
        if (setting === "pushBenachrichtigungenAktiv" && value === true) {
          const permission = await requestPushPermission();
          if (!permission) {
            event.target.checked = false; // Revert toggle
            return;
          }
        }

        const headers = {
          "Content-Type": "application/json",
        };
        if (csrfToken && csrfHeader) {
          headers[csrfHeader] = csrfToken;
        }

        const response = await fetch("/api/profile/notifications/toggle", {
          method: "POST",
          headers: headers,
          body: JSON.stringify({ setting, value }),
        });

        if (!response.ok) {
          throw new Error("Fehler beim Speichern der Einstellung.");
        }

        // If push notification was activated successfully, create subscription
        if (setting === "pushBenachrichtigungenAktiv" && value === true) {
          await subscribeToPush();
        }

        // Optional: show a small toast for successful save
        // Swal.fire({
        //     toast: true,
        //     position: 'top-end',
        //     icon: 'success',
        //     title: 'Gespeichert',
        //     showConfirmButton: false,
        //     timer: 1500
        // });
      } catch (error) {
        console.error(error);
        event.target.checked = !value; // Revert on failure
        Swal.fire({
          icon: "error",
          title: "Fehler",
          text: "Die Einstellung konnte nicht gespeichert werden.",
        });
      }
    });
  });
});

async function requestPushPermission() {
  if (!("Notification" in window)) {
    Swal.fire({
      icon: "error",
      title: "Nicht unterstützt",
      text: "Dein Browser unterstützt keine Desktop-Benachrichtigungen.",
    });
    return false;
  }

  const permission = await Notification.requestPermission();

  if (permission !== "granted") {
    Swal.fire({
      icon: "warning",
      title: "Berechtigung fehlt",
      text: "Du musst Benachrichtigungen in deinem Browser zulassen, um diese Funktion zu nutzen.",
    });
    return false;
  }

  return true;
}

async function subscribeToPush() {
  if (!("serviceWorker" in navigator)) {
    return;
  }

  try {
    const registration = await navigator.serviceWorker.register("/sw.js");
    const configElement = document.getElementById("push-config");
    if (!configElement || !configElement.dataset.vapidPublicKey) {
      console.error("VAPID Public Key not found");
      return;
    }

    const applicationServerKey = urlB64ToUint8Array(configElement.dataset.vapidPublicKey);

    const subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: applicationServerKey,
    });

    const csrfToken = document.querySelector('meta[name="_csrf"]')?.getAttribute("content");
    const csrfHeader = document.querySelector('meta[name="_csrf_header"]')?.getAttribute("content");

    const headers = {
      "Content-Type": "application/json",
    };
    if (csrfToken && csrfHeader) {
      headers[csrfHeader] = csrfToken;
    }

    const subJson = subscription.toJSON();

    await fetch("/api/profile/notifications/push-subscription", {
      method: "POST",
      headers: headers,
      body: JSON.stringify({
        endpoint: subJson.endpoint,
        keys: subJson.keys,
      }),
    });
  } catch (error) {
    console.error("Fehler bei der Push-Subscription:", error);
  }
}

// Utility function to convert VAPID key
function urlB64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/\-/g, "+").replace(/_/g, "/");

  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}
